import React, { memo } from "react";
import "./AuroraText.css";

export const AuroraText = memo(
  ({
    children,
    className = "",
    colors = ["#FF6B2B", "#FFD700", "#F97316", "#FF9153"],
    speed = 0.8,
    delay = 0,
  }) => {
    const gradientStyle = {
      backgroundImage: `linear-gradient(135deg, ${colors.join(", ")}, ${
        colors[0]
      })`,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      animationDuration: `${10 / speed}s`,
    };

    return (
      <span
        className={`aurora-text-container ${className}`}
        style={{ animationDelay: `${delay}s` }}
      >
        <span className="sr-only">{children}</span>
        <span
          className="aurora-text-content"
          style={gradientStyle}
          aria-hidden="true"
        >
          {children}
        </span>
      </span>
    );
  }
);

AuroraText.displayName = "AuroraText";
